// ── Helpers & constants shared across InboxPage sub-components ────────────────

export const CRM_STATUS_OPTIONS = [
  { value: "lead",      label: "Lead",       color: "#3B82F6" },
  { value: "contacted", label: "Contactado", color: "#8B5CF6" },
  { value: "proposal",  label: "Propuesta",  color: "#F59E0B" },
  { value: "won",       label: "Ganado",     color: "#10B981" },
  { value: "lost",      label: "Perdido",    color: "#EF4444" },
];

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = Date.now() - d;
  const m = Math.floor(diff / 60000);
  if (m < 1) return "ahora";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const days = Math.floor(h / 24);
  if (days < 7) return `${days}d`;
  return d.toLocaleDateString("es-UY", { day: "numeric", month: "short" });
}

const AVATAR_COLORS = ["#6366f1","#ec4899","#14b8a6","#f59e0b","#ef4444","#8b5cf6","#06b6d4","#10b981","#f97316"];
function avatarColor(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

export function Avatar({ name, size = "md" }) {
  const initials = (name || "?").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  const sz = size === "sm" ? "w-8 h-8 text-xs" : "w-11 h-11 text-sm";
  return (
    <div className={`${sz} rounded-full flex items-center justify-center font-bold text-white flex-shrink-0`}
      style={{ background: avatarColor(name) }}>
      {initials}
    </div>
  );
}

export function avatarFirstLetter(name) {
  return (name || "?")[0].toUpperCase();
}

export { avatarColor };
